<template>
  <base-button
    :class="[classBgColor]"
    class="ps-flex ps-items-center ps-justify-center ps-px-2 ps-py-1 ps-text-xs ps-font-bold ps-rounded ps-outline-none"
    @button-click="$emit('button-click')"
    :disabled="disabled"
  >
    <span class="">
      <slot />
    </span>
  </base-button>
</template>

<script>
import BaseButton from './BaseButton'

export default {
  name: 'button-pill',
  props: {
    disabled: Boolean,
    bgColor: {
      type: String,
      default: 'brand-brown-400'
    },
    hoverBgColor: {
      type: String
    }
  },
  computed: {
    classBgColor() {
      return `ps-bg-${this.bgColor}`
    }
  },
  components: {
    BaseButton
  }
}
</script>